export default {
  state: {
    basicInfo: null
  },
  mutations: {
    setBasicPostInfo(state, payload) {
      state.basicInfo = payload;
      localStorage.setItem('k-po-m', JSON.stringify(payload));
    }
  },
  actions: {
    setBasicPostInfo(context, payload) {
      if (payload) {
        context.commit('setBasicPostInfo', payload);
      }
    }
  },
  getters: {},
  namespaced: true
};
